<template>
  <v-col cols="12" @click.stop="" v-if="showBadges">
    <v-container>
      <v-row>
        <v-col
          v-for="(item, i) in coreCard.coreValues"
          cols="12"
          md="4"
          :key="i"
        >
          <v-badge
            :color="badgeColor(item)"
            :content="badgeContent(item)"
            overlap
          >
            <avatar
              :badgeUrl="item.badgeUrl"
              :fill="$vuetify.theme.themes.light.secondarytext"
              :size="55"
            >
              <template v-slot:tooltip>
                {{ item.name }}
              </template>
            </avatar>
          </v-badge>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: "CoreCardCoreValues",
  props: {
    coreCard: { type: Object },
    formatValue: { type: Boolean, default: false }
  },
  watch: {},
  data: () => ({
    slide: null
  }),
  computed: {
    badgeColor() {
      return cv => {
        if (this.coreCard.type == this.$enums.coreCardTypes.MISSION_VALUE) {
          return this.$coreScores.getColor(cv.value);
        }
        return "secondarytext";
      };
    },
    showBadges() {
      return this.coreCard.type != this.$enums.coreCardTypes.RECOGNITION;
    }
  },
  methods: {
    badgeContent(item) {
      let value = this.formatValue
        ? this.$coreScores.format(item.value)
        : item.value;
      if (this.coreCard.type == this.$enums.coreCardTypes.MISSION_VALUE) {
        return parseFloat(value).toFixed(1);
      }
      if (Math.round(value) == 0) {
        return "0";
      }
      return `${Math.round(value)}x`;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  min-width: inherit;
}
</style>
